import { Button, Modal } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

export interface EntityDeleteModalProps {
  entityType: 'survey' | 'widget';
  isOpen: boolean;
  isDeletePending: boolean;
  // FIXME: This errors out becuase the prop is unused in the second component.
  //        Components should live in separate files with their own props definitions.
  // eslint-disable-next-line react/no-unused-prop-types
  entityName?: string;
  onClose: () => void;
  onDelete: () => void;
}

export function EntityDeleteModal({
  entityName,
  isOpen,
  isDeletePending,
  onClose,
  onDelete,
  entityType,
}: EntityDeleteModalProps): JSX.Element {
  const { t } = useTranslation('feedback');
  return (
    <Modal
      contentLabel={t('EntityActions.delete.aria-label', { entityType })}
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Header title={t('EntityActions.delete.modal-title', { entityType })} />
      <Modal.Body>{t('EntityActions.delete.confirmation', { entityType, entityName })}</Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" isLoading={isDeletePending} onClick={onClose}>
          {t('EntityActions.delete.cancel')}
        </Button>
        <Button kind="danger" isLoading={isDeletePending} onClick={onDelete}>
          {t('EntityActions.delete.delete')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export function EntityResponseDeleteModal({
  isOpen,
  isDeletePending,
  onClose,
  onDelete,
  entityType,
}: EntityDeleteModalProps): JSX.Element {
  const { t } = useTranslation('feedback');
  return (
    <Modal
      contentLabel={t('EntityActions.delete-response.aria-label', { entityType })}
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Header title={t('EntityActions.delete-response.modal-title')} />
      <Modal.Body>{t('EntityActions.delete-response.confirmation')}</Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" isLoading={isDeletePending} onClick={onClose}>
          {t('EntityActions.delete-response.cancel')}
        </Button>
        <Button kind="danger" isLoading={isDeletePending} onClick={onDelete}>
          {t('EntityActions.delete-response.delete')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
